export const blockBackNavigationMixin = {
  data() {
    return {
      fromName: '',
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fromName = from.name
    })
  },
  beforeRouteLeave(to, from, next) {
    const { name: toName } = to
    if (toName === this.fromName) {
      return next(false)
    }

    next()
  },
}
